import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Shield } from 'lucide-react';
import { Navbar } from '../components/layout/Navbar';
import { useLanguage } from '../hooks/useLanguage';
export function PrivacyPolicyPage() {
  const {
    language
  } = useLanguage();
  const isRTL = language === 'ar';
  return <div className="min-h-screen bg-gray-50" dir={isRTL ? 'rtl' : 'ltr'} data-id="element-2742">
      <Navbar data-id="element-2743" />

      <div className="max-w-4xl mx-auto px-4 py-12" data-id="element-2744">
        <Link to="/" className="inline-flex items-center gap-2 text-[#4f1964] hover:text-[#3d1350] mb-8 transition-colors" data-id="element-2745">
          <ArrowLeft className={`w-4 h-4 ${isRTL ? 'rotate-180' : ''}`} data-id="element-2746" />
          <span data-id="element-2747">{isRTL ? 'العودة للرئيسية' : 'Back to Home'}</span>
        </Link>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="bg-white rounded-2xl shadow-lg p-8 md:p-12" data-id="element-2748">
          <div className="flex items-center gap-4 mb-8" data-id="element-2749">
            <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center" data-id="element-2750">
              <Shield className="w-8 h-8 text-[#4f1964]" data-id="element-2751" />
            </div>
            <div data-id="element-2752">
              <h1 className="text-3xl font-bold text-gray-900" data-id="element-2753">
                {isRTL ? 'سياسة الخصوصية' : 'Privacy Policy'}
              </h1>
              <p className="text-gray-500 mt-1" data-id="element-2754">
                {isRTL ? 'آخر تحديث: يناير 2025' : 'Last updated: January 2025'}
              </p>
            </div>
          </div>

          <div className="prose prose-lg max-w-none" data-id="element-2755">
            {isRTL ? <>
                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2756">
                  مقدمة
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2757">
                  في Operines، نحن ملتزمون بحماية خصوصيتك وأمان بياناتك. توضح
                  سياسة الخصوصية هذه كيفية جمع واستخدام وحماية معلوماتك الشخصية
                  عند استخدام منصتنا.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2758">
                  المعلومات التي نجمعها
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-2759">
                  نقوم بجمع الأنواع التالية من المعلومات:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-2760">
                  <li data-id="element-2761">معلومات الحساب: الاسم، البريد الإلكتروني، رقم الهاتف</li>
                  <li data-id="element-2762">معلومات الأعمال: اسم النشاط التجاري، الفئة، الوصف</li>
                  <li data-id="element-2763">بيانات الاستخدام: كيفية تفاعلك مع منصتنا</li>
                  <li data-id="element-2764">معلومات تقنية: عنوان IP، نوع المتصفح، نظام التشغيل</li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2765">
                  كيف نستخدم معلوماتك
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-2766">
                  نستخدم معلوماتك من أجل:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-2767">
                  <li data-id="element-2768">تقديم وتحسين خدماتنا</li>
                  <li data-id="element-2769">التواصل معك بشأن حسابك والتحديثات</li>
                  <li data-id="element-2770">معالجة المعاملات والفواتير</li>
                  <li data-id="element-2771">تخصيص تجربتك</li>
                  <li data-id="element-2772">ضمان أمان المنصة ومنع الاحتيال</li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2773">
                  مشاركة البيانات
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2774">
                  نحن لا نبيع معلوماتك الشخصية. قد نشارك بياناتك مع مزودي خدمات
                  موثوقين يساعدوننا في تشغيل منصتنا، مثل خدمات الاستضافة ومعالجة
                  الدفع، وذلك فقط بالقدر اللازم لتقديم خدماتنا.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2775">
                  أمان البيانات
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2776">
                  نستخدم تدابير أمنية متقدمة لحماية معلوماتك، بما في ذلك التشفير
                  والتخزين الآمن وضوابط الوصول. ومع ذلك، لا يمكن لأي طريقة نقل
                  عبر الإنترنت أن تكون آمنة بنسبة 100%.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2777">
                  حقوقك
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-2778">
                  لديك الحق في:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-2779">
                  <li data-id="element-2780">الوصول إلى بياناتك الشخصية</li>
                  <li data-id="element-2781">تصحيح المعلومات غير الدقيقة</li>
                  <li data-id="element-2782">طلب حذف بياناتك</li>
                  <li data-id="element-2783">الاعتراض على معالجة بياناتك</li>
                  <li data-id="element-2784">طلب نقل البيانات</li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2785">
                  الاتصال بنا
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2786">
                  إذا كانت لديك أي أسئلة حول سياسة الخصوصية هذه، يرجى الاتصال
                  بنا على:
                  <br data-id="element-2787" />
                  <a href="mailto:hello@operines.ai" className="text-[#4f1964] hover:underline font-medium" data-id="element-2788">
                    hello@operines.ai
                  </a>
                </p>
              </> : <>
                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2789">
                  Introduction
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2790">
                  At Operines, we are committed to protecting your privacy and
                  securing your data. This Privacy Policy explains how we
                  collect, use, and safeguard your personal information when you
                  use our platform.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2791">
                  Information We Collect
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-2792">
                  We collect the following types of information:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-2793">
                  <li data-id="element-2794">Account Information: Name, email, phone number</li>
                  <li data-id="element-2795">
                    Business Information: Business name, category, description
                  </li>
                  <li data-id="element-2796">Usage Data: How you interact with our platform</li>
                  <li data-id="element-2797">
                    Technical Information: IP address, browser type, operating
                    system
                  </li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2798">
                  How We Use Your Information
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-2799">
                  We use your information to:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-2800">
                  <li data-id="element-2801">Provide and improve our services</li>
                  <li data-id="element-2802">Communicate with you about your account and updates</li>
                  <li data-id="element-2803">Process transactions and billing</li>
                  <li data-id="element-2804">Personalize your experience</li>
                  <li data-id="element-2805">Ensure platform security and prevent fraud</li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2806">
                  Data Sharing
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2807">
                  We do not sell your personal information. We may share your
                  data with trusted service providers who help us operate our
                  platform, such as hosting and payment processing services,
                  only to the extent necessary to provide our services.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2808">
                  Data Security
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2809">
                  We use industry-standard security measures to protect your
                  information, including encryption, secure storage, and access
                  controls. However, no method of transmission over the internet
                  can be 100% secure.
                </p>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2810">
                  Your Rights
                </h2>
                <p className="text-gray-700 leading-relaxed mb-4" data-id="element-2811">
                  You have the right to:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2 mb-6" data-id="element-2812">
                  <li data-id="element-2813">Access your personal data</li>
                  <li data-id="element-2814">Correct inaccurate information</li>
                  <li data-id="element-2815">Request deletion of your data</li>
                  <li data-id="element-2816">Object to data processing</li>
                  <li data-id="element-2817">Request data portability</li>
                </ul>

                <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4" data-id="element-2818">
                  Contact Us
                </h2>
                <p className="text-gray-700 leading-relaxed mb-6" data-id="element-2819">
                  If you have any questions about this Privacy Policy, please
                  contact us at:
                  <br data-id="element-2820" />
                  <a href="mailto:hello@operines.ai" className="text-[#4f1964] hover:underline font-medium" data-id="element-2821">
                    hello@operines.ai
                  </a>
                </p>
              </>}
          </div>
        </motion.div>
      </div>
    </div>;
}